export * from "./serviceMarketingCategoryRequest";
export * from "./serviceMarketingCategoryResponse";
export { default } from "./serviceMarketingCategoryApiHttp";
